import styled from 'styled-components';

export const Container = styled.header`
  align-items: center;
  background-image: linear-gradient(to right, #0077e6 , #0fbfad);
  display: flex;
  height: 66px;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 1;

  img {
    max-height: 50px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/TopHeader/styles.js